var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.66,46.62c0-7.76,0-15.53,0-23.29.21.14.43.26.63.41,5.66,3.98,11.32,7.96,16.98,11.94,1.3.92,1.93.92,3.22.02,5.7-3.97,11.4-7.93,17.1-11.9.21-.15.43-.29.73-.48v6.79c0,5.19,0,10.38-.01,15.58,0,.44-.08.91-.27,1.3-.45.89-1.26,1.12-2.22,1.11-11.22-.01-22.44,0-33.66,0-.2,0-.4,0-.6-.02-.61-.06-1.09-.35-1.45-.84-.15-.2-.29-.4-.43-.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.05,20.99h31.82c-.24.2-.37.34-.52.44-4.94,3.46-9.89,6.91-14.82,10.38-.38.27-.64.33-1.05.03-4.95-3.49-9.92-6.96-14.88-10.43-.14-.1-.27-.21-.55-.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.db070ad0d37151330db5ecbf50fcd24e.svg";
export { ForwardRef as ReactComponent };